module.exports = __webpack_public_path__ + "img/symphony_516_bordeaux.d6371367.jpg";